// frontend/src/components/quizzes/QuizQuestionCard.tsx

import { QuizQuestionPublic } from '../../types/quiz.types';
import { MathFormulaRenderer } from '../common/MathFormulaRenderer';

const LETTERS = ['A', 'B', 'C', 'D', 'E', 'F'];

interface QuizQuestionCardProps {
  question: QuizQuestionPublic;
  questionIndex: number;
  totalQuestions: number;
  selectedAnswer: string | undefined;
  onSelect: (answer: string) => void;
  topicLabel: string;
}

export function QuizQuestionCard({
  question,
  questionIndex,
  totalQuestions,
  selectedAnswer,
  onSelect,
  topicLabel,
}: QuizQuestionCardProps) {
  return (
    <div className="quiz-container">
      <div className="quiz-top-row">
        <div>
          <span className="lesson-badge primary">{topicLabel}</span>
        </div>
        <div className="quiz-progress-label">
          Soru {questionIndex + 1} / {totalQuestions}
        </div>
      </div>

      <div className="quiz-question">
        <MathFormulaRenderer text={question.question} isBlock={true} />
      </div>

      {question.type === 'multiple_choice' && question.options.length > 0 ? (
        <div className="quiz-options">
          {question.options.map((option, i) => (
            <div
              key={i}
              className={`quiz-option ${selectedAnswer === option ? 'selected' : ''}`}
              onClick={() => onSelect(option)}
              role="button"
              tabIndex={0}
            >
              <div className="quiz-option-letter">{LETTERS[i] ?? i + 1}</div>
              <div className="quiz-option-content">
                <MathFormulaRenderer text={option} />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="quiz-free-answer">
          <textarea
            placeholder={
              question.type === 'fill_blank'
                ? 'Boşluğu doldur...'
                : question.type === 'code_completion'
                  ? 'Kodu tamamla...'
                  : 'Hatayı bul ve açıkla...'
            }
            value={selectedAnswer ?? ''}
            onChange={(e) => onSelect(e.target.value)}
            spellCheck={false}
          />
        </div>
      )}
    </div>
  );
}

